import { useState } from "react";
import { Product } from "../../../services/types/product.type";
import { BorderWrap } from "../../ui/wrappers/BorderWrap/BorderWrap";
import "./StockItem.css";
import { ItemMenu } from "../../ui/ItemMenu/ItemMenu";
import { TextButton } from "../../ui/buttons/TextButton/TextButton";
import { ProductHeader } from "../../ui/ProductHeader/ProductHeader";

interface StockItemProps {
  item: Product;
  editAction: (uuid: string, name: string) => void;
  updatePage: () => void;
}

const gatewayUrl = process.env.REACT_APP_GATEWAY_URL || "";

export const StockItem = ({ item, editAction, updatePage }: StockItemProps) => {
  const [showMenu, setShowMenu] = useState(false);

  const menuClick = () => {
    setShowMenu((showMenu) => !showMenu);
  };

  const editItem = () => {
    editAction(item.uuid, item.name);
    setShowMenu(false);
  };

  return (
    <BorderWrap>
      <ItemMenu showMenu={showMenu} menuClick={menuClick}>
        <TextButton text="Редактировать" action={editItem} />
      </ItemMenu>
      <ProductHeader
        image={
          item && item.images.length > 0
            ? gatewayUrl + item.images[0].imageUrl
            : undefined
        }
        name={item.name}
        productType={item.productType.name}
        collection={item.collection.name}
      />
    </BorderWrap>
  );
};
